import { useCallback, useEffect } from 'react';

import ListItem from 'components/ListItem';
import ModalFooter from 'components/ModalFooter';
import ModalHeader from 'components/ModalHeader';
import CloseIcon from 'components/icons/CloseIcon';

import handleEvent from 'utilities/handleEvent';

import styles from './styles.module.scss';

const ModalWindow = ({
    backButtonClicked,
    backButtonDisabled,
    children,
    closeIconClassName = '',
    contentClassName = '',
    footerButtonClassName = '',
    footerButtonClicked,
    footerButtonDisabled,
    footerClassName,
    footerId,
    footerLabel = 'Close',
    headerClassName = '',
    headerHeadingClassName = '',
    headerIcon,
    headerIconAlt = '',
    headerIconClassName,
    headerText,
    headerTextClassName = '',
    headerTitle = '',
    isSkip = false,
    isBack = false,
    modalBoxClassName = '',
    onClose,
    skipButtonClassName = '',
    skipButtonClicked,
    skipButtonDisabled,
    skipButtonLabel = 'Skip',
    hideFooter = false
}) => {
    const ESCAPE = 27;
    const ENTER = 13;
    const SPACE = 32;

    const reEnableScroll = useCallback(() => {
        document.body.classList.remove(styles.disableScroll);
    }, []);

    const handleClose = useCallback(
        () => handleEvent(onClose, reEnableScroll),
        [onClose, reEnableScroll]
    )();

    const handleKeyDown = useCallback(
        event => {
            event.preventDefault();

            if (
                event.keyCode === ENTER ||
                event.keyCode === ESCAPE ||
                event.keyCode === SPACE
            ) {
                handleClose(event);
            }
        },
        [handleClose]
    );

    useEffect(() => {
        document.body.classList.add(styles.disableScroll);

        return reEnableScroll;
    }, [reEnableScroll]);

    return (
        <div className={`${styles.modalWindow} ${modalBoxClassName}`}>
            <div className={`${headerClassName} ${styles.header}`}>
                <ListItem className={styles.listItem}>
                    <div className={styles.closeIcon}>
                        <CloseIcon
                            className={`${closeIconClassName} ${styles.closeIconClassName}`}
                            onClick={handleClose}
                            onKeyDown={handleKeyDown}
                            tabIndex="0"
                        />
                    </div>

                    <ModalHeader
                        headerHeadingClassName={headerHeadingClassName}
                        headerIconClassName={headerIconClassName}
                        headerTextClassName={headerTextClassName}
                        icon={headerIcon}
                        iconAlt={headerIconAlt}
                        text={headerText}
                        title={headerTitle}
                    />
                </ListItem>
            </div>

            <div
                className={`${contentClassName} ${styles.content} ${
                    hideFooter ? styles.contentBorder : ''
                } modalContent`}
            >
                {children}
            </div>

            {/* {hideFooter ? null : footerBody()} */}
            {hideFooter ? null : (
                <ModalFooter
                    backButtonClicked={backButtonClicked}
                    backButtonDisabled={backButtonDisabled}
                    footerButtonClassName={footerButtonClassName}
                    skipButtonClicked={skipButtonClicked}
                    footerButtonClicked={footerButtonClicked}
                    footerButtonDisabled={footerButtonDisabled}
                    footerClassName={footerClassName}
                    footerId={footerId}
                    footerLabel={footerLabel}
                    isSkip={isSkip}
                    isBack={isBack}
                    skipButtonClassName={skipButtonClassName}
                    skipButtonDisabled={skipButtonDisabled}
                    skipButtonLabel={skipButtonLabel}
                />
            )}
        </div>
    );
};

export default ModalWindow;
